import { Helmet } from "react-helmet-async";

/**
 * SEO component — drop this into any page to set custom
 * title, description, keywords and canonical URL per page.
 *
 * Usage:
 *   <SEO
 *     title="MCA College Jalandhar | LKCTC"
 *     description="Best MCA college in Jalandhar, Punjab..."
 *     keywords="MCA college Jalandhar, ..."
 *     canonical="https://www.lkctc.edu.in/mca"
 *   />
 */

const BASE_TITLE = "Lyallpur Khalsa College Technical Campus | Best College Jalandhar Punjab";
const BASE_DESCRIPTION =
  "LKCTC Jalandhar – Punjab's top AICTE-approved college. B.Tech, MCA, MBA, BCA, BBA, AI/ML, B.Voc, AHS, Pharmacy, Diploma. IKG-PTU affiliated. Admissions Open 2026-27. Call +91-8847262500.";
const BASE_KEYWORDS =
  "best college Jalandhar, best engineering college Punjab, MCA BCA MBA BBA B.Tech college Jalandhar, LKCTC, Lyallpur Khalsa College Technical Campus, AI ML college Punjab, B.Voc college Jalandhar, AHS college Punjab, pharmacy college Jalandhar, AICTE approved IKG PTU affiliated";
const BASE_URL = "https://www.lkctc.edu.in";
const OG_IMAGE = "https://www.lkctc.edu.in/og-image.jpg";

const SEO = ({
  title = BASE_TITLE,
  description = BASE_DESCRIPTION,
  keywords = BASE_KEYWORDS,
  canonical,
  ogImage = OG_IMAGE,
  ogType = "website",
}) => {
  const fullCanonical = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      {/* ── Primary ── */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
      <meta
        name="robots"
        content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
      />

      {/* ── Open Graph ── */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="LKCTC Jalandhar" />

      {/* ── Twitter ── */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
